<template>
	<div class="newsDtailContainer">
		<!-- 导航 -->
		<div class="navBar">
			<img class="navLogo" src="../assets/logo2.png" alt="">
			<ul class="navBarItem">
				<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
				<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
				<el-dropdown>
					<li><router-link to="/huaiBrand" exact style="font-size:1em;" tag="a">兰树品牌</router-link></li>
					<el-dropdown-menu class="elDropdown" slot="dropdown">
						<el-dropdown-item><router-link to="/huaiBrand" tag="a">淮树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/shuiBrand" tag="a">水姻缘</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/yiBrand" tag="a">一清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span></span></router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/lanshuBrand" tag="a">兰树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zbqfBrand" tag="a">植本清方</router-link></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
				<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
				<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
				
				<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>
				

				<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
			</ul>
		</div>

		<div class="newsMainBox">
			<div class="newsMain">
				<el-breadcrumb class="breadMiddle" separator="/">
					<el-breadcrumb-item :to="{ path: '/brandLanshu' }">美业菩提</el-breadcrumb-item>
					<el-breadcrumb-item>美业菩提节</el-breadcrumb-item>
					<el-breadcrumb-item>详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="videoMainMiddle">
					<div class="newsMainMiddle">
						<div class="newsTitle1">{{ contentText.title }}</div>
						<div class="newsDate">{{ contentText.create_time }}</div>
						<p class="fuContent" v-html="contentText.content"></p>
					</div>
					<div :class="this.$route.query.videoUrl == null ? 'none' : 'block'" v-html="videoDetails">
					</div>
					
				</div>
			</div>
			<!-- 底部 -->
			<div class="footerOuter">
				<div class="footerBox">

					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						<!-- <div class="footerBoxHeaderRight">
									<img class="codeImg" src="../assets/code.png" alt="">
									<span class="codeText">兰树客服(QQ)</span>
								</div> -->

					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>

					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
					</div>



					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
								href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
							<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>
					<div style="width: 100%;height: 40px;"></div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { myGet, myPost, login } from "@/api/http";
export default {
	data() {
		return {
			contentText: [],
			videoDetails: '',
			config2: {
				id: 'mse2',
				url: '',
				volume: 1,
				autoplay: false,
			},
			Player2: null,
		}
	},
	created() {
		this.gitDetails();
		this.playVideo()
	},
	methods: {
		gitDetails() {
			let that = this;
			let userId = this.$route.query.userId;
			myPost("api/messages/", {
				id: userId,
			}).then((res) => {
				console.log("res", res.data)
				that.contentText = res.data
				if (res.data.code == 200) {

				}
			});
		},
		// 视频
		playVideo() {
			let that = this;
			let videoUrl = that.$route.query.videoUrl;
			// this.config2.url = videoUrl;
			// console.log('video',123);
			that.config2.url = videoUrl;


			this.videoDetails = `<video
						 					  id="threeMyVideo"
						 					  class="video-js vjs-big-play-centered vjs-fluid"
						 					  controls
						 					  preload="auto"
						 					  width="100%"
						 					  height="100%"
						 					  poster=""
						 					>
						 						<source
						    type="` + (videoUrl.includes('.m3u8') ? 'application/x-mpegURL' : 'video/mp4') + `"
						     src="` + videoUrl + `"
						    >
						 					</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			this.videoHeight = window.innerHeight;
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner = false;
				this.isVideo = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('threeMyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: true,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					//   width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					//   height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});
			// myPost("api/messages/", {
			//   id: that.$route.query.userId,
			// }).then((res) => {
			// 	console.log("userId",res.data);

			// });	  
		},
	}
}
</script>

<style scoped>
.newsDtailContainer {
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

/* 导航 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}

.router-link-active {
	background-color: #0F3F93;
	color: #FFFFFF;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	/* justify-content: flex-end;
		margin-right: 8em; */
}

.navBarItem li {
	list-style: none;
	/* padding: 1.5em 2.5em 1.5em 2.5em; */
	float: left;
	/* margin-left: 2em; */
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 2em;
	padding-right: 2em;
}


.elDropdown {
	margin-left: -5em;
	margin-top: 0em;
}

.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.newsMainBox {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #F6F6F6;
	position: absolute;
}

.newsMainMiddle {
	width: 80%;
	display: flex;
	flex-direction: column;
	background: #FFFFFF;
	margin: 0 auto;
	margin-top: 2em;
}

.videoMainMiddle {
	width: 80%;
	display: flex;
	flex-direction: column;
	background: #FFFFFF;
	margin: 0 auto;
	margin-top: 2em;
}



.newsTitle1 {
	width: 90%;
	font-size: 1.375em;
	font-family: MicrosoftYaHei;
	color: #222222;
	line-height: 29px;
	margin: 0 auto;
	margin-top: 1em;
}

.newsTitle2 {
	width: 90%;
	margin: 0 auto;
	text-align: center;
	font-size: 0.875em;
	font-family: MicrosoftYaHei;
	color: #222222;
	line-height: 19px;
	margin-top: 2em;
}

.newsDate {
	width: 90%;
	margin: 0 auto;
	font-size: 0.75em;
	font-family: MicrosoftYaHei;
	color: #999999;
	line-height: 16px;
	margin-top: 2em;
}

.newsText1 {
	width: 70%;
	font-size: 0.875em;
	font-family: MicrosoftYaHei;
	color: #666666;
	line-height: 19px;
	margin: 0 auto;
	margin-top: 2em;
}

.newsText2 {
	width: 70%;
	font-size: 0.875em;
	font-family: MicrosoftYaHei;
	color: #666666;
	line-height: 19px;
	margin: 0 auto;
	margin-top: 2em;
}


.newsText3 {
	width: 70%;
	font-size: 0.875em;
	font-family: MicrosoftYaHei;
	color: #666666;
	line-height: 19px;
	margin: 0 auto;
	margin-top: 2em;
	padding-bottom: 5em;
}

.newsImg1 {
	width: 70%;
	margin: 0 auto;
	margin-top: 2em;
}

.newsImg2 {
	width: 70%;
	margin: 0 auto;
	margin-top: 2em;
}

/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #F8F9FB;
	/* position:absolute;
	 	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
	margin-top: 1rem;
}


.footerOuter {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F8F9FB;
}

.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}


.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	padding-left: 2em;
	line-height: 28px;
}

.newsMain {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0 auto;
	position: relative;
	margin-top: 5em;
	background: #F6F6F6;
	padding-bottom: 2em;
}


.breadMiddle {
	width: 80%;
	margin: 0 auto;
}

.fuContent {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 2rem;
	margin-top: 1rem;
}

.block {
	display: block;
	width: 100%;
}

.none {
	display: none;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/putiDetail.vue